/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, ContainerProps, mapProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$ButtonRuby} from '@gongxigames/framework/slotV2/ui/ui-ruby/JSX/ButtonRuby';

export type SoundBtnProps = Omit<ContainerProps, 'name'> & CanBeSignals<{
    soundEnabled: boolean;
    disabled?: boolean;
    action?: () => void;
}>;

export const $SoundBtn: FC<SoundBtnProps> = (props) => {
    const icon = mapProp(props.soundEnabled, enabled => enabled ? 'btn_icon_sound' : 'btn_icon_sound_off');

    return <$ButtonRuby
        icon={icon}
        bg='round_btn_bg'
        {...props}
        hitArea='round'
    />;
};